import classNames from 'classnames';
import './NavMenu.scss';
import { LogoProps } from '@components/nav/Logo';

export interface NavMenuProps {
  /** sets the "icon" to either close (x) or hamburger */
  isActive?: boolean;
  /** aria-label for active state (e.g. "Close Menu") */
  activeLabel?: string;
  /** aria-label for default state (e.g. "Open Menu") */
  defaultLabel?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  /** brand type for modifying menu icon (pplus or pluto) */
  brand?: LogoProps['brand'];
}

/**
 * NavMenu - A button to toggle the navigation menu.
 * Displays a hamburger icon on default and an X when isActive.
 * @param isActive - sets the "icon" to either close (x) or hamburger
 * @param activeLabel - aria-label for active state (e.g. "Close Menu")
 * @param defaultLabel - aria-label for default state (e.g. "Open Menu")
 * @param onClick - callback for click event
 * @param className - additional class name
 * @param brand - brand type for modifying menu icon (pplus or pluto)
 */
export const NavMenu: React.FC<NavMenuProps> = ({
  isActive,
  activeLabel,
  defaultLabel,
  onClick,
  className,
  brand = 'pplus',
}) => (
  <button
    className={classNames('vds-nav-menu', className, {
      'vds-nav-menu--pplus': brand === 'pplus',
    })}
    aria-label={isActive ? activeLabel : defaultLabel}
    aria-expanded={isActive}
    role="button"
    onClick={onClick}>
    <div className={classNames('vds-nav-menu__icon', isActive && 'vds-nav-menu__icon-active')}>
      <div className="vds-nav-menu__bar" />
    </div>
  </button>
);
